import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import TypeArticleService from "../../../services/TypeArticleService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function TypeArticleModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  typeArticleTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);
  useEffect(() => {
    if (typeArticleTarget) {
      setformField([
        { name: ["name"], value: typeArticleTarget.name },
      ]);
    }
  }, [typeArticleTarget]);

  const onFinish = (values) => {
    let typeArticleR = { ...values };
    //console.log("values", values);
    if (typeArticleTarget) {
        typeArticleR.id = typeArticleTarget.id;
          TypeArticleService.updateTypeArticle(typeArticleR)
            .then((res) => {
              if (res.data?.success) {
                message.success("Tipo de Artículo actualizado.", 3);
                handleOk();
              } else {
                message.error(
                  "No se pudo actualizar el Tipo de Artículo. " + res.data?.description,
                  5
                );
              }
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("Hubo un error. " + e.message, 5);
            });
        } else {
          TypeArticleService.createTypeArtcile(typeArticleR)
            .then((res) => {
              if (res.data?.success) {
                message.success("Tipo de Artículo registrado.", 3);
                handleOk();
              } else {
                message.error(
                  "No se pudo registar el Tipo de Artículo. " + res.data?.description,
                  5
                );
              }
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("Hubo un error. " + e.message);
            });
        }
  };
  return (
    <Modal
      title="Registrar Tipo de artículo"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre del tipo de artículo"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre del tipo de artículo.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
